// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"62dac052","965":"f9601170"}[chunkId] + ".chunk.css";
};